module.exports = __webpack_public_path__ + "img/Silverman-Case-Study-600px.8ee73d25.png";